// usePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', process.env.REACT_APP_FIREBASE_MEASUREMENT_ID, {
        page_path: location.pathname,
      });
    }
  }, [location]);
}
